// 显示登录或者注册
// showLogin(false);
// showLogin(true);
window.showLogin = function (bl) {
    hideLoginEle();

    if (bl === undefined || bl == false) {
        $('.top-login-state').show();
        $('.top-login-name').show();
        $('.top-login-pass').show();
        $('.top-login-btn').show();
        $('.top-login-reg-link').show();
        $('.top-login-lostpass').show();

        $('.top-login-name').focus();
        $('.top-login-icon').text('登录');
    } else {
        // 注册
        $('.top-reg-name').show();
        $('.top-reg-verificationcode').show();
        $('.top-reg-getcode').show();
        $('.top-reg-validate-btn').show();
        $('.top-login-link').show();

        $('.top-reg-name').focus();
        $('.top-login-icon').text('注册');
    }
};

window.showResetPwd = function () {
    hideLoginEle();

    $('.top-reg-name').show();
    $('.top-reg-verificationcode').show();
    $('.top-reg-getcode').show();
    $('.top-validate-btn').show();
    $('.top-login-link').show();

    $('.top-reg-name').focus();
    $('.top-login-icon').text('重置密码');

};

window.hideLoginEle = function () {
    $('.top-login-pop').show();
    $('.top-login-msg').text('');

    $('.top-login-name').hide();
    $('.top-login-pass').hide();
    $('.top-login-btn').hide();
    $('.top-login-reg-link').hide();
    $('.top-login-lostpass').hide();

    $('.top-login-state').hide();
    $('.top-reg-name-login').hide();
    $('.top-reg-verificationcode-login').hide();
    $('.top-reg-getcode-login').hide();


    $('.top-reg-name').hide();
    $('.top-reg-verificationcode').hide();
    $('.top-reg-getcode').hide();
    $('.top-reg-validate-btn').hide();
    $('.top-reg-btn').hide();
    $('.top-login-link').hide();

    $('.top-reg-pass').hide();
    $('.top-reg-nickname').hide();

    $('.top-validate-btn').hide();
    $('.top-reg-pass2').hide();
    $('.top-resetpwd-btn').hide();
};

window.checkUsername = function (username) {
    // var pattern = new RegExp('^[a-zA-Z0-9_]{6,20}$');
    var pattern = new RegExp('^1\\d{10}$');

    if (!pattern.test(username)) {
        return false;

    }
    return true;
};

window.checkPassword = function (password) {
    var pattern = new RegExp('^([A-Z]|[a-z]|[0-9]|[` _\\-~!@#$%^&*()+=|{}\':;\',\\[\\].<>/?~！@#￥%……&*（）+|{}【】‘；：”“\'。，、？]){6,20}$');

    if (!pattern.test(password)) {
        return false;

    }
    return true;
};

$(function () {
    var urlParams = {};
    window.getUrlParams = function () {
        var query = location.search.substring(1);// 获取查询串
        var pairs = query.split('&');// 在逗号处断开
        for (var i = 0; i < pairs.length; i++) {
            var pos = pairs[i].indexOf('=');// 查找name=value
            if (pos == -1) continue;// 如果没有找到就跳过
            var argname = pairs[i].substring(0, pos);// 提取name
            var value = pairs[i].substring(pos + 1);// 提取value
            urlParams[argname] = decodeURI(value);// 存为属性
        }
    };

    getUrlParams();

    $('.top-login-state-btn').on('click', function () {
        if ($(this).hasClass('top-login-state-user')) {
            // 账户登录
            $('.top-login-state-phone').removeClass('state-btn-active')
            $(this).addClass('state-btn-active')

            $('.top-login-name').show()
            $('.top-login-pass').show()
            $('.top-reg-name-login').hide()
            $('.top-reg-verificationcode-login').hide()
            $('.top-reg-getcode-login').hide()
        } else {
            // 验证码登录
            $('.top-login-state-user').removeClass('state-btn-active')
            $(this).addClass('state-btn-active')

            $('.top-login-name').hide()
            $('.top-login-pass').hide()
            $('.top-reg-name-login').show()
            $('.top-reg-verificationcode-login').show()
            $('.top-reg-getcode-login').show()
        }
    });
    $('.top-reg-getcode-login').on('click', function () {
        getCode(true, $(this), 5)
    });


    $('.top-login').on('click', function () {
        showLogin();
    });

    $('.top-login-link').on('click', function () {
        showLogin();
    });

    $('.top-login-reg-link').on('click', function () {
        showLogin(true);
    });

    $('.top-login-lostpass').on('click', function () {
        showResetPwd();
    });

    $('.top-login-close').on('click', function () {
        $('.top-login-pop').css('display', 'none');
    });

    $('.top-reg-getcode').on('click', function () {
        getCode(false, $(this))
    });
    window.getCode = function (isCodeLogin, _this, codeType) {
        $('.top-login-msg').text('');

        var phoneClassName = '.top-reg-name'
        var codeClassName = '.top-reg-getcode'
        if (isCodeLogin) {
            phoneClassName = '.top-reg-name-login'
            codeClassName = '.top-reg-getcode-login'
        }
        var phone = $.trim($(phoneClassName).val());
        if (phone.length == 0) {
            $('.top-login-msg').text('请输入手机号');
            return;
        }

        var type = 1;
        if ($('.top-login-icon').text() == '重置密码') {
            type = 3;
        }
        if (codeType) {
            type = codeType
        }
        var data = {
            'phone_number': phone,
            'type': type
        };
        var timer = null;
        $.ajax({
            type: 'post',
            async: false,
            url: ROOT + '/shareusers/send-code',
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (data) {
                var sec = 60;
                $(codeClassName).css('background-color', '#e8e8e8');
                $(codeClassName).text('获取验证码(' + sec + 's)');
                _this.off('click');
                timer = setInterval(
                    function name() {
                        $(codeClassName).text('获取验证码(' + sec + 's)');
                        sec -= 1;
                        if (sec < 1) {
                            $(codeClassName).css('background-color', 'rgb(243, 69, 66)');
                            $(codeClassName).text('获取验证码');
                            clearInterval(timer);
                            _this.on('click', function () {
                                getcode(isCodeLogin, _this, codeType);
                            });
                        }
                    }, 1000);
                alert('验证码已发送，请注意查收');
            },
            error: function (data) {
                $('.top-login-msg').text(data.responseText);
            }
        });
    }
    $('.top-login-btn').on('click', function () {
        if ($('.top-login-state-user').hasClass('state-btn-active')) {
            $('.top-login-msg').text('');

            var username = $('.top-login-name').val();
            if (username.length == 0) {
                $('.top-login-msg').text('请输入用户名');
                return;
            }
            var password = $('.top-login-pass').val();

            var remember = true;

            var data = {
                username: username,
                password: password,
                remember: remember
            };

            $.ajax({
                type: 'post',
                async: false,
                url: ROOT + '/shareusers/login',
                data: JSON.stringify(data),
                contentType: 'application/json',
                dataType: 'json',
                success: function (data) {
                    urlParams['token'] = data.token;
                    var query = $.param(urlParams);

                    location.href = 'http://' + location.host + location.pathname + '?' + query;
                },
                error: function (data) {
                    $('.top-login-msg').text(data.responseText);
                }
            });
        } else {
            $('.top-login-msg').text('');

            var phone_number = $('.top-reg-name-login').val();
            if (phone_number.length == 0) {
                $('.top-login-msg').text('请输入手机号');
                return;
            }
            var verification_code = $('.top-reg-verificationcode-login').val();
            if (verification_code.length == 0) {
                $('.top-login-msg').text('请输入验证码');
                return;
            }
            var remember_login = true;

            var data = {
                phone_number: phone_number,
                verification_code: verification_code,
                remember_login: remember_login
            };

            $.ajax({
                type: 'post',
                async: false,
                url: ROOT + '/shareusers/phone-login',
                data: JSON.stringify(data),
                contentType: 'application/json',
                dataType: 'json',
                success: function (data) {
                    console.log(data);
                    urlParams['token'] = data.token;
                    var query = $.param(urlParams);
                    location.href = 'http://' + location.host + location.pathname + '?' + query;
                },
                error: function (data) {
                    $('.top-login-msg').text(data.responseText);
                }
            });
        }

    });

    $('.btn_qq,.btn_weibo,.btn_weixin').on('click', function () {
        // 第三方登录url
        var qqLoginUrl = '/shareusers/third_login?type=qq';
        var weiboLoginUrl = '/shareusers/third_login?type=weibo';
        var weixinLoginUrl = '/shareusers/third_login?type=wechat';


        var state = encodeURIComponent(window.location.href);
        var url = '';
        if ($(this).hasClass('btn_qq')) {
            url = qqLoginUrl;
        } else if ($(this).hasClass('btn_weibo')) {
            url = weiboLoginUrl;
        } else if ($(this).hasClass('btn_weixin')) {
            url = weixinLoginUrl;
        }
        location.href = url + '&state=' + state;
    });

    $('.top-login-inputline').on('keypress', 'input', function (e) {
        if (e.keyCode == 13) {
            $('.top-login-btn').click();
        }
    });

    $('.top-reg-validate-btn').click(function () {
        var username = $('.top-reg-name').val();

        if (!checkUsername(username)) {
            $('.top-login-msg').text('用户名必须是手机号');
            return;
        }

        var verificationcode = $('.top-reg-verificationcode').val();
        if (verificationcode.length == 0) {
            $('.top-login-msg').text('请输入验证码');
            return;
        }

        var data = {
            'phone_number': username,
            'type': 1,
            'verification_code': verificationcode
        };

        $.ajax({
            type: 'post',
            async: false,
            url: ROOT + '/shareusers/verification-code',
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                if (result) {
                    hideLoginEle();

                    $('.top-reg-pass').show();
                    $('.top-reg-nickname').show();
                    $('.top-reg-btn').show();
                } else {
                    $('.top-login-msg').text('验证码无效');
                }
            },
            error: function (data) {
                $('.top-login-msg').text(data.responseText);
            }
        });
    });

    $('.top-reg-btn').click(function () {
        var username = $('.top-reg-name').val();

        if (!checkUsername(username)) {
            $('.top-login-msg').text('用户名必须是手机号');
            return;
        }

        var verificationcode = $('.top-reg-verificationcode').val();
        if (verificationcode.length == 0) {
            $('.top-login-msg').text('请输入验证码');
            return;
        }

        var password = $('.top-reg-pass').val();
        if (!checkPassword(password)) {
            $('.top-login-msg').text('密码长度必须为6-20，由字母、数字、符号组合');
            return;
        }

        var nickname = $('.top-reg-nickname').val();

        var data = {
            'username': username,
            'nickname': nickname,
            'password': password,
            'email': '',
            'phone_number': username,
            'verification_code': verificationcode
        };

        $.ajax({
            type: 'post',
            async: false,
            url: ROOT + '/shareusers/register',
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                showLogin();
            },
            error: function (data) {
                $('.top-login-msg').text(data.responseText);
            }
        });
    });

    $('.top-validate-btn').click(function () {
        var username = $('.top-reg-name').val();

        if (!checkUsername(username)) {
            $('.top-login-msg').text('用户名必须是手机号');
            return;
        }

        var verificationcode = $('.top-reg-verificationcode').val();

        var data = {
            'phone_number': username,
            'type': 3,
            'verification_code': verificationcode
        };

        $.ajax({
            type: 'post',
            async: false,
            url: ROOT + '/shareusers/verification-code',
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                if (result) {
                    hideLoginEle();

                    $('.top-reg-pass').show();
                    $('.top-reg-pass2').show();

                    $('.top-resetpwd-btn').show();
                } else {
                    $('.top-login-msg').text('验证码无效');
                }
            },
            error: function (data) {
                $('.top-login-msg').text(data.responseText);
            }
        });
    });

    $('.top-resetpwd-btn').click(function () {
        var username = $('.top-reg-name').val();
        var password = $('.top-reg-pass').val();
        var password2 = $('.top-reg-pass2').val();
        if (password != password2) {
            $('.top-login-msg').text('两次输入的密码不一致');
            return;
        }

        var verificationcode = $('.top-reg-verificationcode').val();

        var data = {
            'receiver': username,
            'new_password': password,
            'verification_code': verificationcode
        };

        $.ajax({
            type: 'post',
            async: false,
            url: ROOT + '/shareusers/reset-password',
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                showLogin();
            },
            error: function (data) {
                $('.top-login-msg').text(data.responseText);
            }
        });
    });
});

window.logout = function () {
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/shareusers/logout',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            location.reload();
        },
        error: function (data) {
            location.reload();

            // alert(data.responseText);
        }
    });
};